import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import type { IGoodsReceivingService } from '../../../services/goods-receiving';
import { GoodsReceivingService } from '../../../services/goods-receiving';
import { goodsReceivingQueryKeys } from '../query-keys';

/**
 * Hook per recuperare la lista di nomi prodotto univoci.
 * Utilizza TanStack React Query per la gestione dello stato e del caching.
 *
 * @returns Query result con array di stringhe (nomi prodotto)
 */
export function useProductNames() {
  const service = useInjection<IGoodsReceivingService>(GoodsReceivingService);

  return useQuery({
    queryKey: goodsReceivingQueryKeys.productNames(),
    queryFn: async () => {
      return service.getProductNames();
    },
  });
}
